import { useState } from 'react';
import { Button, Grid, Group, Modal, NumberInput } from '@mantine/core';
import ErrorMessage from '../ErrorMessage';

const PreviewOrderStatusPageModal = ({ show, close, baseUrl }) => {
  const [orderId, setOrderId] = useState('');
  const [error, setError] = useState();

  const handlePreview = async () => {
    setError(false);

    if (!orderId) {
      setError('Please, specify order id!');
      return;
    }

    window.open(`${baseUrl}?rlv_odid=${orderId}`, '_blank', 'noopener,noreferrer');
  };

  return (
    <Modal size="lg" opened={show} onClose={() => close()} title="Preview Order Status Page">
      <Grid mb="md">
        <Grid.Col span={{ base: 12, sm: 4 }} style={{ display: 'flex', alignItems: 'center' }}>
          <label>Order Id</label>
        </Grid.Col>
        <Grid.Col span={{ base: 12, sm: 8 }}>
          <NumberInput name="orderId" value={orderId} onChange={(value) => setOrderId(value)} hideControls />
        </Grid.Col>
        <Grid.Col span={12}>
          <ErrorMessage message={error} />
        </Grid.Col>
      </Grid>
      <Group justify="flex-end">
        <Button variant="default" onClick={() => close()}>
          Close
        </Button>
        <Button onClick={handlePreview}>
          Preview
        </Button>
      </Group>
    </Modal>
  );
};

export default PreviewOrderStatusPageModal;
